export const generationZhCN = {
  classroom: {
    recentClassrooms: '最近学习',
    today: '今天',
    yesterday: '昨天',
    daysAgo: '天前',
    slides: '页',
    nameCopied: '课堂名称已复制',
    deleteConfirmTitle: '删除课堂',
    delete: '删除',
  },
  upload: {
    pdfSizeLimit: '支持最大50MB的PDF文件',
    generateFailed: '生成课堂失败，请重试',
    requirementPlaceholder:
      '输入你想学的任何内容，例如：\n「从零学 Python，30 分钟写出第一个程序」\n「用白板给我讲解傅里叶变换」\n「阿瓦隆桌游怎么玩」',
    requirementRequired: '请输入课程需求',
    fileTooLarge: '文件过大，请选择小于50MB的PDF文件',
  },
  generation: {
    // Progress steps (used dynamically via activeStep)
    analyzingPdf: '解析 PDF 文档',
    analyzingPdfDesc: '正在提取文档结构和内容...',
    pdfLoadFailed: '无法加载 PDF 文件，请重试',
    pdfParseFailed: 'PDF 解析失败',
    streamNotReadable: '无法读取生成数据流',
    generatingOutlines: '生成课程大纲',
    generatingOutlinesDesc: '正在构建学习路径...',
    generatingSlideContent: '生成页面内容',
    generatingSlideContentDesc: '正在创建幻灯片、测验和互动内容...',
    generatingActions: '生成教学动作',
    generatingActionsDesc: '正在编排讲解、聚焦和互动流程...',
    generationComplete: '生成完成！',
    generationFailed: '生成失败',
    generatingCourse: '正在生成课程',
    openingClassroom: '即将打开课堂...',
    outlineReady: '课程大纲已生成',
    generatingFirstPage: '首页内容生成中...',
    firstPageReady: '首页已就绪！正在打开课堂...',
    speechFailed: '语音合成失败',
    retryScene: '重试生成',
    retryingScene: '正在重新生成...',
    backToHome: '返回首页',
    sessionNotFound: '未找到生成会话',
    sessionNotFoundDesc: '请先填写课程需求开始生成流程。',
    goBackAndRetry: '返回重试',
    classroomReady: '你的个性化AI学习环境已成功生成。',
    aiWorking: 'AI智能体工作中...',
    textTruncated: '文档文本较长，已截取前 {n} 字符用于生成',
    imageTruncated: '文档含 {total} 张图片，超出上限 {max} 张，多余图片将仅以文字描述传递',
    // Agent generation
    agentGeneration: '生成课堂角色',
    agentGenerationDesc: '正在根据课程内容生成角色...',
    agentRevealTitle: '你的课堂角色',
    viewAgents: '查看角色',
    continue: '继续',
    // Outline errors
    outlineRetrying: '大纲生成异常，正在重试...',
    outlineEmptyResponse: '模型未返回有效的大纲内容，请检查模型配置后重试',
    outlineGenerateFailed: '大纲生成失败，请稍后重试',
    // Web Search
    webSearching: '网络搜索',
    webSearchingDesc: '正在搜索网络获取最新资料',
    webSearchFailed: '网络搜索失败',
  },
} as const;

export const generationEnUS = {
  classroom: {
    recentClassrooms: 'Recent',
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: 'days ago',
    slides: 'slides',
    nameCopied: 'Name copied',
    deleteConfirmTitle: 'Delete',
    delete: 'Delete',
  },
  upload: {
    pdfSizeLimit: 'Supports PDF files up to 50MB',
    generateFailed: 'Failed to generate classroom, please try again',
    requirementPlaceholder:
      'Tell me anything you want to learn, e.g.\n"Teach me Python from scratch in 30 minutes"\n"Explain Fourier Transform on the whiteboard"\n"How to play the board game Avalon"',
    requirementRequired: 'Please enter course requirements',
    fileTooLarge: 'File too large. Please select a PDF file smaller than 50MB',
  },
  generation: {
    // Progress steps (used dynamically via activeStep)
    analyzingPdf: 'Analyzing PDF Document',
    analyzingPdfDesc: 'Extracting document structure and content...',
    pdfLoadFailed: 'Failed to load PDF file, please try again',
    pdfParseFailed: 'PDF parsing failed',
    streamNotReadable: 'Unable to read generation stream',
    generatingOutlines: 'Drafting Course Outline',
    generatingOutlinesDesc: 'Structuring the learning path...',
    generatingSlideContent: 'Generating Page Content',
    generatingSlideContentDesc: 'Creating slides, quizzes, and interactive content...',
    generatingActions: 'Generating Teaching Actions',
    generatingActionsDesc: 'Orchestrating narration, spotlights, and interactions...',
    generationComplete: 'Generation complete!',
    generationFailed: 'Generation failed',
    generatingCourse: 'Generating course',
    openingClassroom: 'Opening classroom...',
    outlineReady: 'Course outline generated',
    generatingFirstPage: 'Generating first page...',
    firstPageReady: 'First page ready! Opening classroom...',
    speechFailed: 'Speech generation failed',
    retryScene: 'Retry',
    retryingScene: 'Regenerating...',
    backToHome: 'Back to Home',
    sessionNotFound: 'Session Not Found',
    sessionNotFoundDesc: 'Please fill in course requirements to start the generation process.',
    goBackAndRetry: 'Go Back and Retry',
    classroomReady: 'Your personalized AI learning environment has been generated successfully.',
    aiWorking: 'AI Agents Working...',
    textTruncated: 'Document text is long, using first {n} characters for generation',
    imageTruncated:
      '{total} images found, exceeding the {max} image limit. Extra images will use text descriptions only',
    // Agent generation
    agentGeneration: 'Generating Classroom Roles',
    agentGenerationDesc: 'Generating roles based on course content...',
    agentRevealTitle: 'Your Classroom Roles',
    viewAgents: 'View Roles',
    continue: 'Continue',
    // Outline errors
    outlineRetrying: 'Outline generation issue, retrying...',
    outlineEmptyResponse:
      'Model returned no valid outlines. Please check model configuration and try again',
    outlineGenerateFailed: 'Outline generation failed, please try again later',
    // Web Search
    webSearching: 'Web Search',
    webSearchingDesc: 'Searching the web for up-to-date information',
    webSearchFailed: 'Web search failed',
  },
} as const;
